import { render } from "./PadelDropdown.vue?vue&type=template&id=377531f2&scoped=true"
import script from "./PadelDropdown.vue?vue&type=script&lang=ts"
export * from "./PadelDropdown.vue?vue&type=script&lang=ts"

import "./PadelDropdown.vue?vue&type=style&index=0&id=377531f2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-377531f2"

export default script